import { createAction } from '@reduxjs/toolkit';
import { SET_DEALER_ID_TEST_RIDE, SET_IS_TEST_RIDE_IFRAME, SET_TEST_RIDE_CATEGORY_ID, } from './actionsTypes';
export const setIsIFrame = createAction(SET_IS_TEST_RIDE_IFRAME);
export const setTestRideDealerId = createAction(SET_DEALER_ID_TEST_RIDE);
export const setTestRideCategoryId = createAction(SET_TEST_RIDE_CATEGORY_ID);
export const actions = {
    isIframe: setIsIFrame,
    testRideDealerId: setTestRideDealerId,
    categoryId: setTestRideCategoryId,
};
